import React, { Component } from "react";
import bgImg from "../data/images/pbbg.jpg";
import { SettingsContext } from ".";
import { playSound } from "../utils/sounds";

const toggle = (dis, key) => () => {
  dis.setState(state => ({ [key]: !state[key] }));
};

const setKeyValue = (dis, key) => val => {
  dis.setState(state => ({ [key]: val }));
};

class SettingsProvider extends Component {
  state = {
    scale: 1,
    crt: true,
    fullScreen: true,
    isMobile: false,
    bgImg:
      (window && window.localStorage.getItem("bgImg")) ||
      (window && !window.localStorage.getItem("loggedIn") && bgImg),
    bgColor: (window && window.localStorage.getItem("bgColor")) || "#fff",
    bgStyle: (window && window.localStorage.getItem("bgStyle")) || "stretch",
    soundEnabled: !(
      window && window.localStorage.getItem("soundEnabled") === "false"
    )
  };

  componentDidMount() {
    if (!this.state.soundEnabled) return;
    const audio = new Audio(
      (process.env.PUBLIC_URL || "") + "/sounds/startup.wav"
    );
    const p = audio.play();
    if (p && p.catch) {
      // If the browser blocks autoplay, stay silent — the sound toggle in
      // the taskbar is the user-driven way to trigger it.
      p.catch(() => {});
    }
  }

  toggleCrt = toggle(this, "crt");
  toggleFullScreen = toggle(this, "fullScreen");
  toggleMobile = toggle(this, "isMobile");
  changeScale = setKeyValue(this, "scale");
  toggleSound = () => {
    this.setState(state => {
      const next = !state.soundEnabled;
      try {
        window.localStorage.setItem("soundEnabled", String(next));
      } catch (_) {}
      if (next) playSound("startup", { force: true });
      return { soundEnabled: next };
    });
  };

  updateLocalStorage = (key, val) => {
    if (window && window.localStorage) {
      window.localStorage.setItem(key, val);
      if (val) {
        this.setState({ [key]: val });
      }
    }
  };
  removeLocalStorage = key => {
    let keys = key;
    if (!Array.isArray(key)) {
      keys = [key];
    }
    if (keys.length < 1) {
      return;
    }
    if (window && window.localStorage) {
      keys.map(k => window.localStorage.removeItem(k));

      this.setState(
        keys.reduce(
          (acc, val) => ({
            ...acc,
            [val]: null
          }),
          {}
        )
      );
    }
  };

  render() {
    const {
      changeScale,
      toggleCrt,
      toggleFullScreen,
      toggleMobile,
      toggleSound,
      updateLocalStorage,
      removeLocalStorage
    } = this;
    const context = {
      ...this.state,
      changeScale,
      toggleCrt,
      toggleFullScreen,
      toggleMobile,
      toggleSound,
      updateLocalStorage,
      removeLocalStorage
    };
    return (
      <SettingsContext.Provider value={context}>
        {this.props.children}
      </SettingsContext.Provider>
    );
  }
}

export default SettingsProvider;
